import React from 'react';
import PropTypes from 'prop-types';
import { P } from 'components/Typography';
import { StyledTips } from './styled';
import { CLAIM_TYPES } from '../../../../consts';

const TipsText = ({ claimType }) => {
  if (claimType === CLAIM_TYPES.TRAVEL) {
    return (
      <P>
        Please let us know if you or any other person involved in the incident is covered
        by another insurance policy. If so, please provide us with the insurance details.
      </P>
    );
  }
  return (
    <ul>
      Please Include: <li>Full list of symptoms and when they began or occurred</li>
      <li>
        If you have ever had or been treated for this condition, describe when and how
      </li>
    </ul>
  );
};

TipsText.propTypes = {
  claimType: PropTypes.string
};

const Tips = ({ claimType }) => {
  return (
    <StyledTips>
      <b>
        <span role="img" aria-label="tip">
          💡
        </span>{' '}
        Tips
      </b>
      <TipsText claimType={claimType} />
    </StyledTips>
  );
};

Tips.propTypes = {
  claimType: PropTypes.string
};

export default Tips;
